import { useCallback, useState } from 'react';

export const useObject = (initialState = {}) => {
  const [state, setState] = useState(initialState);

  const updateValues = useCallback(
    newValues =>
      setState(prevState => ({
        ...prevState,
        ...newValues
      })),
    []
  );

  return {
    state,
    setState,
    updateValues
  };
};
